import { render, staticRenderFns } from "./GonghuoTaskReportTab.vue?vue&type=template&id=06714d26&scoped=true&"
import script from "./GonghuoTaskReportTab.vue?vue&type=script&lang=js&"
export * from "./GonghuoTaskReportTab.vue?vue&type=script&lang=js&"
import style0 from "./GonghuoTaskReportTab.vue?vue&type=style&index=0&id=06714d26&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06714d26",
  null
  
)

export default component.exports